import React from 'react';
import PropTypes from 'prop-types';
import ItemImage from './ItemImage';
import LabelQuantity from './LabelQuantity';

function LeftComponent({ item, withImage }) {
  return withImage ? (
    <ItemImage image={item?.image} />
  ) : (
    <LabelQuantity>{item.quantity}x</LabelQuantity>
  );
}

LeftComponent.propTypes = {
  item: PropTypes.object,
  withImage: PropTypes.bool,
};

export default LeftComponent;
